"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const Grid_1 = __importDefault(require("../Grid/Grid"));
const util_1 = require("../../../util");
function HNavigator(props) {
    const { children, className } = props;
    const ref = (0, react_1.createRef)();
    const [scroll, setScroll] = react_1.default.useState({
        scrollLeft: -1,
        clientWidth: -1,
        scrollRight: -1,
        scrollWidth: -1,
    });
    function updateScroll(el) {
        const { scrollLeft, scrollWidth, clientWidth } = el;
        const scrollRight = scrollWidth - clientWidth - scrollLeft;
        setScroll({ scrollLeft, clientWidth, scrollRight, scrollWidth });
    }
    function doScroll(mode, target) {
        if (!target) {
            return;
        }
        let val = 0;
        if (scroll.clientWidth !== -1) {
            val = scroll.clientWidth * 0.75;
        }
        if (!mode) {
            val *= -1;
        }
        target.scrollBy({ left: val, behavior: 'smooth' });
    }
    (0, react_1.useEffect)(() => {
        if (ref.current) {
            updateScroll(ref.current);
        }
    }, [ref.current]);
    return (react_1.default.createElement(Grid_1.default, { className: "glx-navigator-horizontal--wrapper" },
        react_1.default.createElement("div", { ref: ref, onScroll: (x) => {
                updateScroll(x.currentTarget);
            }, className: (0, util_1.cnx)(className, 'glx-navigator-horizontal', 'glx-no-scroll') },
            children,
            scroll.scrollLeft > 0 ? (react_1.default.createElement("div", { className: "glx-navigator-horizontal--left", onClick: () => doScroll(false, ref.current) },
                react_1.default.createElement(react_icons_1.IOChevronBack, null))) : null,
            scroll.scrollRight > 0 || scroll.scrollRight === -1 ? (react_1.default.createElement("div", { className: "glx-navigator-horizontal--right", onClick: () => doScroll(true, ref.current) },
                react_1.default.createElement(react_icons_1.IOChevronForward, null))) : null)));
}
exports.default = HNavigator;
HNavigator.defaultProps = {
    className: undefined,
};
